import {MaterialType} from '@domain/materials'
import {dataTestId} from '@hconnect/uikit'
import {Grid} from '@mui/material'

import {SimpleStockDevelopmentCard} from '../components'
import {useStoredMaterialIdsQuery, useSearchParams} from '../hooks'

type Props = {
  stockMaterialsOrdersUrl: string
}

export const MaterialsContainer = ({stockMaterialsOrdersUrl}: Props) => {
  const [obtainedParams] = useSearchParams('materialType')
  const obtainedMaterialType = obtainedParams.materialType
  if (obtainedMaterialType === null) {
    throw new Error('BUG: materialType search param should be set before rendering this component')
  }
  const selectedMaterialType = obtainedMaterialType as MaterialType

  const {data: selectedMaterialIds} = useStoredMaterialIdsQuery({
    materialType: selectedMaterialType
  })
  if (!selectedMaterialIds) {
    throw new Error('Bug: storages with material should be loaded to render this component')
  }
  return (
    <Grid container spacing={2} {...dataTestId('page_stockMaterial')}>
      {selectedMaterialIds.map((id) => (
        <Grid key={id} item xs={12} lg={6}>
          <SimpleStockDevelopmentCard
            materialId={id}
            materialIds={selectedMaterialIds}
            stockMaterialsOrdersUrl={stockMaterialsOrdersUrl}
          />
        </Grid>
      ))}
    </Grid>
  )
}
